import fs from 'fs'
import path from 'path'
import {camelCase} from 'lodash/string'
import chalk from 'chalk'
import template from '../templates/model'

export default function (name: string, fields: Array = []) {
    name = name.charAt(0).toUpperCase() + camelCase(name).slice(1);
    const p = path.join(process.cwd(), 'api', 'src', 'models', `${name}.prisma`);
    console.log(chalk.yellow(`Generating ${name} model to ${p}`));
    fs.writeFileSync(p, template(name, fields.map(f => (ps => ({name: ps[0], type: ps[1], directives: ps[2]}))(f.split(':')))))
}
